export default class Constants {
    static readonly DEFAULT_GRADE_THEME = '7';

    static readonly GRADE_MIN_FONT_SIZES = {
        TK: 20,
        K: 20,
        '1': 18,
        '2': 16,
        default: 14,
    };

    static readonly SEARCH_DEBOUNCE_MS = 200;

    static readonly API_BASE_URL =
        typeof import.meta !== 'undefined' && import.meta.env
            ? import.meta.env.MODE === 'development'
                ? 'https://localhost:5143/api/'
                : import.meta.env.MODE === 'staging'
                  ? 'https://classroom-api-staging.paradigmmath.com/api/'
                  : 'https://classroom-api.paradigmmath.com/api/'
            : 'https://classroom-api.paradigmmath.com/api/';

    static readonly MAX_CHARS = {
        TITLE: 100,
        EXAM_ASSIGNMENT_DESCRIPTION: 500,
        XML: 200,
        HANDSCORE_INSTRUCTIONS: 500,
        URL_PATH: 200,
        NAME: 50,
        EMAIL: 200,
        USERNAME: 100,
        PASSWORD: 64,
        SSID: 100,
        DISTRICT_FIELDS: 100,
        DISTRICT_STATE_CODE: 10,
        SCHOOL_FIELDS: 100,
        CLASS_NAME: 200,
    };

    static readonly USER_TYPE_MASTER_IDS = {
        SUPER_ADMIN: 1,
        TEACHER: 2,
        STUDENT: 3,
        DISTRICT_ADMIN: 4,
        SCHOOL_ADMIN: 5,
    };

    static readonly QUESTION_TYPE_MASTER_IDS = {
        MULTIPLE_CHOICE: 1,
        OPEN_TEXT: 2,
        MULTIPLE_SELECT: 3,
        MATRIX: 4,
        HOTSPOT: 5,
        DRAG_AND_DROP: 6,
        STIMULUS: 7,
        SEGMENT: 8,
        GRAPHING: 9,
        DYNAMIC: 10,
    };
    static readonly EXAM_TYPE_MASTER_IDS = {
        UNIT_TEST: 1,
        BENCHMARK: 2,
        DIAGNOSTIC: 3,
    };
    static readonly EXAM_ASSIGNMENT_TYPE_MASTER_IDS = {
        CLASS: 1,
        STUDENT: 2,
    };

    static readonly ROLES = {
        SUPER_ADMIN: 'Super Admin',
        DISTRICT_ADMIN: 'District Admin',
        SCHOOL_ADMIN: 'School Admin',
        TEACHER: 'Teacher',
        STUDENT: 'Student',
        COACH: 'Coach',
    };

    static readonly ALL_ROLES = [
        Constants.ROLES.SUPER_ADMIN,
        Constants.ROLES.DISTRICT_ADMIN,
        Constants.ROLES.SCHOOL_ADMIN,
        Constants.ROLES.TEACHER,
        Constants.ROLES.STUDENT,
    ];

    static readonly ALL_NON_STUDENT_ROLES = [
        Constants.ROLES.SUPER_ADMIN,
        Constants.ROLES.DISTRICT_ADMIN,
        Constants.ROLES.SCHOOL_ADMIN,
        Constants.ROLES.TEACHER,
    ];

    static readonly ALL_ADMIN_ROLES = [
        Constants.ROLES.SUPER_ADMIN,
        Constants.ROLES.DISTRICT_ADMIN,
        Constants.ROLES.SCHOOL_ADMIN,
    ];

    static readonly bandColors: Record<string, string> = {
        Below: '#ff0000',
        'Not Met': '#ff0000',
        Near: '#ffff00',
        Nearly: '#ffff00',
        Exceeds: '#0000ff',
        Met: '#008000',
        'At/Above': '#008000',
    };

    static readonly fieldLabels: Record<string, string> = {
        districtId: 'District',
        schoolId: 'School',
        gradeLevelMasterId: 'Grade Level',
        classId: 'Class',
        examId: 'Assessment',
        examIds: 'Assessment(s)',
    };

    static readonly DTE_DEFAULT_TEXT = '<p></p>';
    static readonly DEE_DEFAULT_TEXT = '{"nodes":[]}';
}
